module.exports = __webpack_public_path__ + "static/media/Logo-SGB-Orange.7188a341.png";